import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageRow from './MessageRow';
import { messagesType } from '../../types';
import './_styles_/MessagesList.css';

MessagesList.propTypes = {
    messages: messagesType.isRequired,
};

function MessagesList(props) {
    const {
        messages,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="messages-list">
            <div className="rich-list-row rich-list-header messages-list--header">
                <div className="message-header--values--last-update-time">
                    {t('messages.list-header.last-update-time')}
                </div>
                <div className="message-header--values--message">
                    {t('messages.list-header.message')}
                </div>
            </div>
            {
                messages.length
                    ? messages.map((message) => <MessageRow message={message} key={message.id} />)
                    : (<div className="messages-no-items">{t('messages.no-items')}</div>)
            }
        </div>
    );
}

export default MessagesList;
